import { AppModalLocale } from "../index";

const locale: AppModalLocale = {
  name: 'name',
  code: 'code',
  type: 'type',
  desc: 'description',
};

export default locale
